import { jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCarouselControls } from '../../hooks/useCarouselControls.js';
import { renderArrows } from '../LinkButton/renderArrows.js';
import { renderInnerTableRow } from './renderInnerTableRow.js';
export const InnerTableBodyItem = JSX(({ rows }) => {
    const rowsLength = rows?.[0]?.length ?? 0;
    const CARD_VIEW_COUNT = 5;
    const [activeIndex, controls] = useCarouselControls({
        itemCount: rowsLength,
        visibleItemCount: CARD_VIEW_COUNT,
    });
    return (_jsxs("div", { children: [rows?.map(renderInnerTableRow(activeIndex)), renderArrows({
                ...controls,
                btnClass: ['left-3 top-20', 'right-3 top-20'],
                className: '',
            })] }));
});
//# sourceMappingURL=InnerTableBodyItem.js.map